// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file message/message_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message as Message$1 } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type {
  GraphicSize,
  LinkPreview,
  ReactionCountData,
  StickerType,
} from '../common/common_model_pb';
import { file_common_common_model } from '../common/common_model_pb';
import type { SystemMessage } from './message_system_model_pb';
import { file_message_message_system_model } from './message_system_model_pb';

/**
 * Describes the file message/message_model.proto.
 */
export const file_message_message_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_common_common_model, file_message_message_system_model]
  );

/**
 * @generated from message com.gem.bff.contract.Message
 */
export type Message = Message$1<'com.gem.bff.contract.Message'> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 chatId = 2;
   */
  chatId: bigint;

  /**
   * @generated from field: int64 senderId = 3;
   */
  senderId: bigint;

  /**
   * @generated from field: string clientUuid = 4;
   */
  clientUuid: string;

  /**
   * @generated from field: int64 serverTs = 5;
   */
  serverTs: bigint;

  /**
   * @generated from field: optional int64 editTs = 6;
   */
  editTs?: bigint;

  /**
   * @generated from field: int64 clientTs = 7;
   */
  clientTs: bigint;

  /**
   * @generated from field: optional com.gem.bff.contract.QuotedMessage quotedMessage = 8;
   */
  quotedMessage?: QuotedMessage;

  /**
   * @generated from field: optional com.gem.bff.contract.QuotedMessageData quotedMessageData = 15;
   */
  quotedMessageData?: QuotedMessageData;

  /**
   * @generated from field: optional com.gem.bff.contract.ForwardedSource forwardedSource = 9;
   */
  forwardedSource?: ForwardedSource;

  /**
   * @generated from field: com.gem.bff.contract.MessagePayload payload = 10;
   */
  payload?: MessagePayload;

  /**
   * @generated from field: com.gem.bff.contract.Reactions reactions = 11;
   */
  reactions?: Reactions;

  /**
   * @generated from field: int64 viewsCount = 12;
   */
  viewsCount: bigint;

  /**
   * @generated from field: optional string deepLink = 13;
   */
  deepLink?: string;

  /**
   * @generated from field: repeated string links = 14;
   */
  links: string[];
};

/**
 * Describes the message com.gem.bff.contract.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 0);

/**
 * @generated from enum com.gem.bff.contract.Message.DeleteMode
 */
export enum Message_DeleteMode {
  /**
   * @generated from enum value: FOR_ALL = 0;
   */
  FOR_ALL = 0,

  /**
   * @generated from enum value: FOR_ME = 1;
   */
  FOR_ME = 1,
}

/**
 * Describes the enum com.gem.bff.contract.Message.DeleteMode.
 */
export const Message_DeleteModeSchema: GenEnum<Message_DeleteMode> =
  /*@__PURE__*/
  enumDesc(file_message_message_model, 0, 0);

/**
 * @generated from enum com.gem.bff.contract.Message.Direction
 */
export enum Message_Direction {
  /**
   * @generated from enum value: NEW = 0;
   */
  NEW = 0,

  /**
   * @generated from enum value: OLD = 1;
   */
  OLD = 1,
}

/**
 * Describes the enum com.gem.bff.contract.Message.Direction.
 */
export const Message_DirectionSchema: GenEnum<Message_Direction> =
  /*@__PURE__*/
  enumDesc(file_message_message_model, 0, 1);

/**
 * @generated from enum com.gem.bff.contract.Message.MediaType
 */
export enum Message_MediaType {
  /**
   * @generated from enum value: AudioMessage = 0;
   */
  AudioMessage = 0,

  /**
   * @generated from enum value: Album = 1;
   */
  Album = 1,

  /**
   * @generated from enum value: Article = 2;
   */
  Article = 2,

  /**
   * @generated from enum value: Link = 3;
   */
  Link = 3,

  /**
   * @generated from enum value: File = 4;
   */
  File = 4,

  /**
   * @generated from enum value: Image = 5;
   */
  Image = 5,

  /**
   * @generated from enum value: Video = 6;
   */
  Video = 6,

  /**
   * @generated from enum value: VoiceMessage = 7;
   */
  VoiceMessage = 7,
}

/**
 * Describes the enum com.gem.bff.contract.Message.MediaType.
 */
export const Message_MediaTypeSchema: GenEnum<Message_MediaType> =
  /*@__PURE__*/
  enumDesc(file_message_message_model, 0, 2);

/**
 * @generated from message com.gem.bff.contract.MessagePayload
 */
export type MessagePayload = Message$1<'com.gem.bff.contract.MessagePayload'> & {
  /**
   * @generated from oneof com.gem.bff.contract.MessagePayload.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.AlbumPayload album = 1;
         */
        value: AlbumPayload;
        case: 'album';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.FilePayload file = 2;
         */
        value: FilePayload;
        case: 'file';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ImagePayload image = 3;
         */
        value: ImagePayload;
        case: 'image';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.StickerPayload sticker = 4;
         */
        value: StickerPayload;
        case: 'sticker';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.TextPayload text = 5;
         */
        value: TextPayload;
        case: 'text';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.VideoPayload video = 6;
         */
        value: VideoPayload;
        case: 'video';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.VoicePayload voice = 7;
         */
        value: VoicePayload;
        case: 'voice';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.OrderedItemPayload orderedItem = 8;
         */
        value: OrderedItemPayload;
        case: 'orderedItem';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SystemMessage systemMessage = 9;
         */
        value: SystemMessage;
        case: 'systemMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UnsupportedPayload unsupported = 10;
         */
        value: UnsupportedPayload;
        case: 'unsupported';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AudioPayload audio = 11;
         */
        value: AudioPayload;
        case: 'audio';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.E2eePayload e2ee = 12;
         */
        value: E2eePayload;
        case: 'e2ee';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.MessagePayload.
 * Use `create(MessagePayloadSchema)` to create a new message.
 */
export const MessagePayloadSchema: GenMessage<MessagePayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 1);

/**
 * @generated from message com.gem.bff.contract.ForwardedSource
 */
export type ForwardedSource = Message$1<'com.gem.bff.contract.ForwardedSource'> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: optional int64 chatId = 2;
   */
  chatId?: bigint;

  /**
   * @generated from field: int64 messageId = 3;
   */
  messageId: bigint;

  /**
   * @generated from field: int64 senderId = 4;
   */
  senderId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.ForwardedSource.
 * Use `create(ForwardedSourceSchema)` to create a new message.
 */
export const ForwardedSourceSchema: GenMessage<ForwardedSource> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 2);

/**
 * @generated from message com.gem.bff.contract.QuotedMessage
 */
export type QuotedMessage = Message$1<'com.gem.bff.contract.QuotedMessage'> & {
  /**
   * @generated from field: int64 messageId = 1;
   */
  messageId: bigint;

  /**
   * @generated from field: com.gem.bff.contract.MessagePayload payload = 2;
   */
  payload?: MessagePayload;

  /**
   * @generated from field: int64 senderId = 3;
   */
  senderId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.QuotedMessage.
 * Use `create(QuotedMessageSchema)` to create a new message.
 */
export const QuotedMessageSchema: GenMessage<QuotedMessage> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 3);

/**
 * @generated from message com.gem.bff.contract.QuotedMessageData
 */
export type QuotedMessageData = Message$1<'com.gem.bff.contract.QuotedMessageData'> & {
  /**
   * @generated from field: com.gem.bff.contract.Source source = 1;
   */
  source?: Source;

  /**
   * @generated from oneof com.gem.bff.contract.QuotedMessageData.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.QuotedMessageData.Reply reply = 2;
         */
        value: QuotedMessageData_Reply;
        case: 'reply';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.QuotedMessageData.Text text = 3;
         */
        value: QuotedMessageData_Text;
        case: 'text';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.QuotedMessageData.
 * Use `create(QuotedMessageDataSchema)` to create a new message.
 */
export const QuotedMessageDataSchema: GenMessage<QuotedMessageData> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 4);

/**
 * @generated from message com.gem.bff.contract.QuotedMessageData.Reply
 */
export type QuotedMessageData_Reply = Message$1<'com.gem.bff.contract.QuotedMessageData.Reply'> & {
  /**
   * @generated from field: com.gem.bff.contract.MessagePayload payload = 1;
   */
  payload?: MessagePayload;
};

/**
 * Describes the message com.gem.bff.contract.QuotedMessageData.Reply.
 * Use `create(QuotedMessageData_ReplySchema)` to create a new message.
 */
export const QuotedMessageData_ReplySchema: GenMessage<QuotedMessageData_Reply> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 4, 0);

/**
 * @generated from message com.gem.bff.contract.QuotedMessageData.Text
 */
export type QuotedMessageData_Text = Message$1<'com.gem.bff.contract.QuotedMessageData.Text'> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message com.gem.bff.contract.QuotedMessageData.Text.
 * Use `create(QuotedMessageData_TextSchema)` to create a new message.
 */
export const QuotedMessageData_TextSchema: GenMessage<QuotedMessageData_Text> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 4, 1);

/**
 * @generated from message com.gem.bff.contract.Source
 */
export type Source = Message$1<'com.gem.bff.contract.Source'> & {
  /**
   * @generated from oneof com.gem.bff.contract.Source.source
   */
  source:
    | {
        /**
         * @generated from field: com.gem.bff.contract.Source.User user = 1;
         */
        value: Source_User;
        case: 'user';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.Source.Chat chat = 2;
         */
        value: Source_Chat;
        case: 'chat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.Source.UserChat userChat = 3;
         */
        value: Source_UserChat;
        case: 'userChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.Source.Unknown unknown = 4;
         */
        value: Source_Unknown;
        case: 'unknown';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.Source.
 * Use `create(SourceSchema)` to create a new message.
 */
export const SourceSchema: GenMessage<Source> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 5);

/**
 * @generated from message com.gem.bff.contract.Source.User
 */
export type Source_User = Message$1<'com.gem.bff.contract.Source.User'> & {
  /**
   * @generated from field: int64 userId = 1;
   */
  userId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.Source.User.
 * Use `create(Source_UserSchema)` to create a new message.
 */
export const Source_UserSchema: GenMessage<Source_User> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 5, 0);

/**
 * @generated from message com.gem.bff.contract.Source.Chat
 */
export type Source_Chat = Message$1<'com.gem.bff.contract.Source.Chat'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: int64 messageId = 2;
   */
  messageId: bigint;

  /**
   * @generated from field: string title = 3;
   */
  title: string;
};

/**
 * Describes the message com.gem.bff.contract.Source.Chat.
 * Use `create(Source_ChatSchema)` to create a new message.
 */
export const Source_ChatSchema: GenMessage<Source_Chat> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 5, 1);

/**
 * @generated from message com.gem.bff.contract.Source.UserChat
 */
export type Source_UserChat = Message$1<'com.gem.bff.contract.Source.UserChat'> & {
  /**
   * @generated from field: com.gem.bff.contract.Source.Chat chat = 1;
   */
  chat?: Source_Chat;

  /**
   * @generated from field: com.gem.bff.contract.Source.User user = 2;
   */
  user?: Source_User;
};

/**
 * Describes the message com.gem.bff.contract.Source.UserChat.
 * Use `create(Source_UserChatSchema)` to create a new message.
 */
export const Source_UserChatSchema: GenMessage<Source_UserChat> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 5, 2);

/**
 * @generated from message com.gem.bff.contract.Source.Unknown
 */
export type Source_Unknown = Message$1<'com.gem.bff.contract.Source.Unknown'> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;
};

/**
 * Describes the message com.gem.bff.contract.Source.Unknown.
 * Use `create(Source_UnknownSchema)` to create a new message.
 */
export const Source_UnknownSchema: GenMessage<Source_Unknown> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 5, 3);

/**
 * @generated from message com.gem.bff.contract.Reactions
 */
export type Reactions = Message$1<'com.gem.bff.contract.Reactions'> & {
  /**
   * @generated from field: optional int64 currentUserReaction = 1;
   */
  currentUserReaction?: bigint;

  /**
   * @generated from field: repeated com.gem.bff.contract.ReactionCountData usersReactions = 2;
   */
  usersReactions: ReactionCountData[];
};

/**
 * Describes the message com.gem.bff.contract.Reactions.
 * Use `create(ReactionsSchema)` to create a new message.
 */
export const ReactionsSchema: GenMessage<Reactions> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 6);

/**
 * @generated from message com.gem.bff.contract.AlbumPayload
 */
export type AlbumPayload = Message$1<'com.gem.bff.contract.AlbumPayload'> & {
  /**
   * @generated from field: optional string comment = 1;
   */
  comment?: string;

  /**
   * @generated from field: repeated com.gem.bff.contract.UserMention userMentions = 2;
   */
  userMentions: UserMention[];

  /**
   * @generated from field: repeated com.gem.bff.contract.OrderedItemPayload payloads = 3;
   */
  payloads: OrderedItemPayload[];
};

/**
 * Describes the message com.gem.bff.contract.AlbumPayload.
 * Use `create(AlbumPayloadSchema)` to create a new message.
 */
export const AlbumPayloadSchema: GenMessage<AlbumPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 7);

/**
 * @generated from message com.gem.bff.contract.UserMention
 */
export type UserMention = Message$1<'com.gem.bff.contract.UserMention'> & {
  /**
   * @generated from field: int64 userId = 1;
   */
  userId: bigint;

  /**
   * @generated from field: string nickname = 2;
   */
  nickname: string;
};

/**
 * Describes the message com.gem.bff.contract.UserMention.
 * Use `create(UserMentionSchema)` to create a new message.
 */
export const UserMentionSchema: GenMessage<UserMention> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 8);

/**
 * @generated from message com.gem.bff.contract.OrderedItemPayload
 */
export type OrderedItemPayload = Message$1<'com.gem.bff.contract.OrderedItemPayload'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 order = 2;
   */
  order: number;

  /**
   * @generated from field: com.gem.bff.contract.MessagePayload payload = 3;
   */
  payload?: MessagePayload;
};

/**
 * Describes the message com.gem.bff.contract.OrderedItemPayload.
 * Use `create(OrderedItemPayloadSchema)` to create a new message.
 */
export const OrderedItemPayloadSchema: GenMessage<OrderedItemPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 9);

/**
 * @generated from message com.gem.bff.contract.FileData
 */
export type FileData = Message$1<'com.gem.bff.contract.FileData'> & {
  /**
   * @generated from field: string fileName = 1;
   */
  fileName: string;

  /**
   * @generated from field: int64 fileSize = 2;
   */
  fileSize: bigint;

  /**
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * @generated from field: string mimeType = 4;
   */
  mimeType: string;
};

/**
 * Describes the message com.gem.bff.contract.FileData.
 * Use `create(FileDataSchema)` to create a new message.
 */
export const FileDataSchema: GenMessage<FileData> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 10);

/**
 * @generated from message com.gem.bff.contract.FilePayload
 */
export type FilePayload = Message$1<'com.gem.bff.contract.FilePayload'> & {
  /**
   * @generated from field: com.gem.bff.contract.FileData fileData = 1;
   */
  fileData?: FileData;

  /**
   * @generated from field: optional string comment = 2;
   */
  comment?: string;

  /**
   * @generated from field: repeated com.gem.bff.contract.UserMention userMentions = 3;
   */
  userMentions: UserMention[];
};

/**
 * Describes the message com.gem.bff.contract.FilePayload.
 * Use `create(FilePayloadSchema)` to create a new message.
 */
export const FilePayloadSchema: GenMessage<FilePayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 11);

/**
 * @generated from message com.gem.bff.contract.ImagePayload
 */
export type ImagePayload = Message$1<'com.gem.bff.contract.ImagePayload'> & {
  /**
   * @generated from field: com.gem.bff.contract.FileData fileData = 1;
   */
  fileData?: FileData;

  /**
   * @generated from field: optional string comment = 2;
   */
  comment?: string;

  /**
   * @generated from field: repeated com.gem.bff.contract.UserMention userMentions = 3;
   */
  userMentions: UserMention[];

  /**
   * @generated from field: com.gem.bff.contract.GraphicSize graphicSize = 4;
   */
  graphicSize?: GraphicSize;

  /**
   * @generated from field: bool stretchedByWidth = 5;
   */
  stretchedByWidth: boolean;
};

/**
 * Describes the message com.gem.bff.contract.ImagePayload.
 * Use `create(ImagePayloadSchema)` to create a new message.
 */
export const ImagePayloadSchema: GenMessage<ImagePayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 12);

/**
 * @generated from message com.gem.bff.contract.StickerPayload
 */
export type StickerPayload = Message$1<'com.gem.bff.contract.StickerPayload'> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 stickerPackId = 2;
   */
  stickerPackId: bigint;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string stickerUrl = 4;
   */
  stickerUrl: string;

  /**
   * @generated from field: com.gem.bff.contract.StickerType type = 5;
   */
  type: StickerType;

  /**
   * @generated from field: optional string animationUrl = 6;
   */
  animationUrl?: string;

  /**
   * @generated from field: com.gem.bff.contract.GraphicSize graphicSize = 7;
   */
  graphicSize?: GraphicSize;
};

/**
 * Describes the message com.gem.bff.contract.StickerPayload.
 * Use `create(StickerPayloadSchema)` to create a new message.
 */
export const StickerPayloadSchema: GenMessage<StickerPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 13);

/**
 * @generated from message com.gem.bff.contract.TextPayload
 */
export type TextPayload = Message$1<'com.gem.bff.contract.TextPayload'> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: repeated com.gem.bff.contract.UserMention userMentions = 2;
   */
  userMentions: UserMention[];

  /**
   * @generated from field: optional com.gem.bff.contract.LinkPreview linkPreview = 3;
   */
  linkPreview?: LinkPreview;
};

/**
 * Describes the message com.gem.bff.contract.TextPayload.
 * Use `create(TextPayloadSchema)` to create a new message.
 */
export const TextPayloadSchema: GenMessage<TextPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 14);

/**
 * @generated from message com.gem.bff.contract.UnsupportedPayload
 */
export type UnsupportedPayload = Message$1<'com.gem.bff.contract.UnsupportedPayload'> & {};

/**
 * Describes the message com.gem.bff.contract.UnsupportedPayload.
 * Use `create(UnsupportedPayloadSchema)` to create a new message.
 */
export const UnsupportedPayloadSchema: GenMessage<UnsupportedPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 15);

/**
 * @generated from message com.gem.bff.contract.VideoPayload
 */
export type VideoPayload = Message$1<'com.gem.bff.contract.VideoPayload'> & {
  /**
   * @generated from field: com.gem.bff.contract.FileData fileData = 1;
   */
  fileData?: FileData;

  /**
   * @generated from field: optional string comment = 2;
   */
  comment?: string;

  /**
   * @generated from field: repeated com.gem.bff.contract.UserMention userMentions = 3;
   */
  userMentions: UserMention[];

  /**
   * @generated from field: com.gem.bff.contract.GraphicSize graphicSize = 4;
   */
  graphicSize?: GraphicSize;

  /**
   * @generated from field: optional string previewUrl = 5;
   */
  previewUrl?: string;
};

/**
 * Describes the message com.gem.bff.contract.VideoPayload.
 * Use `create(VideoPayloadSchema)` to create a new message.
 */
export const VideoPayloadSchema: GenMessage<VideoPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 16);

/**
 * @generated from message com.gem.bff.contract.VoicePayload
 */
export type VoicePayload = Message$1<'com.gem.bff.contract.VoicePayload'> & {
  /**
   * @generated from field: com.gem.bff.contract.FileData fileData = 1;
   */
  fileData?: FileData;

  /**
   * @generated from field: optional string comment = 2;
   */
  comment?: string;

  /**
   * @generated from field: repeated com.gem.bff.contract.UserMention userMentions = 3;
   */
  userMentions: UserMention[];

  /**
   * @generated from field: int64 duration = 4;
   */
  duration: bigint;

  /**
   * @generated from field: string histogram = 5;
   */
  histogram: string;
};

/**
 * Describes the message com.gem.bff.contract.VoicePayload.
 * Use `create(VoicePayloadSchema)` to create a new message.
 */
export const VoicePayloadSchema: GenMessage<VoicePayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 17);

/**
 * @generated from message com.gem.bff.contract.AudioPayload
 */
export type AudioPayload = Message$1<'com.gem.bff.contract.AudioPayload'> & {
  /**
   * @generated from field: com.gem.bff.contract.FileData fileData = 1;
   */
  fileData?: FileData;

  /**
   * @generated from field: optional string comment = 2;
   */
  comment?: string;

  /**
   * @generated from field: repeated com.gem.bff.contract.UserMention userMentions = 3;
   */
  userMentions: UserMention[];

  /**
   * @generated from field: optional string artist = 4;
   */
  artist?: string;

  /**
   * @generated from field: optional string title = 5;
   */
  title?: string;

  /**
   * @generated from field: int64 duration = 6;
   */
  duration: bigint;
};

/**
 * Describes the message com.gem.bff.contract.AudioPayload.
 * Use `create(AudioPayloadSchema)` to create a new message.
 */
export const AudioPayloadSchema: GenMessage<AudioPayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 18);

/**
 * @generated from message com.gem.bff.contract.E2eePayload
 */
export type E2eePayload = Message$1<'com.gem.bff.contract.E2eePayload'> & {
  /**
   * @generated from field: int64 epoch = 1;
   */
  epoch: bigint;

  /**
   * @generated from field: string senderDeviceId = 2;
   */
  senderDeviceId: string;

  /**
   * @generated from field: bytes payload = 3;
   */
  payload: Uint8Array;

  /**
   * @generated from field: optional bytes selfPayload = 4;
   */
  selfPayload?: Uint8Array;
};

/**
 * Describes the message com.gem.bff.contract.E2eePayload.
 * Use `create(E2eePayloadSchema)` to create a new message.
 */
export const E2eePayloadSchema: GenMessage<E2eePayload> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 19);

/**
 * @generated from message com.gem.bff.contract.MessageKey
 */
export type MessageKey = Message$1<'com.gem.bff.contract.MessageKey'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: int64 messageId = 2;
   */
  messageId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.MessageKey.
 * Use `create(MessageKeySchema)` to create a new message.
 */
export const MessageKeySchema: GenMessage<MessageKey> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 20);

/**
 * @generated from message com.gem.bff.contract.MessageCountData
 */
export type MessageCountData = Message$1<'com.gem.bff.contract.MessageCountData'> & {
  /**
   * @generated from field: com.gem.bff.contract.Message.MediaType type = 1;
   */
  type: Message_MediaType;

  /**
   * @generated from field: int64 counts = 2;
   */
  counts: bigint;
};

/**
 * Describes the message com.gem.bff.contract.MessageCountData.
 * Use `create(MessageCountDataSchema)` to create a new message.
 */
export const MessageCountDataSchema: GenMessage<MessageCountData> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 21);

/**
 * @generated from message com.gem.bff.contract.ScheduledMessage
 */
export type ScheduledMessage = Message$1<'com.gem.bff.contract.ScheduledMessage'> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 chatId = 2;
   */
  chatId: bigint;

  /**
   * @generated from field: string clientUuid = 3;
   */
  clientUuid: string;

  /**
   * @generated from field: int64 clientTs = 4;
   */
  clientTs: bigint;

  /**
   * @generated from field: int64 serverTs = 5;
   */
  serverTs: bigint;

  /**
   * @generated from field: int64 delayMs = 6;
   */
  delayMs: bigint;

  /**
   * @generated from field: optional string status = 7;
   */
  status?: string;

  /**
   * @generated from field: com.gem.bff.contract.MessagePayload payload = 8;
   */
  payload?: MessagePayload;

  /**
   * @generated from field: optional com.gem.bff.contract.QuotedMessageData quotedMessageData = 9;
   */
  quotedMessageData?: QuotedMessageData;
};

/**
 * Describes the message com.gem.bff.contract.ScheduledMessage.
 * Use `create(ScheduledMessageSchema)` to create a new message.
 */
export const ScheduledMessageSchema: GenMessage<ScheduledMessage> =
  /*@__PURE__*/
  messageDesc(file_message_message_model, 22);
